<template>
  <div class="order-page">
    <van-nav-bar title="确认下单" left-arrow @click-left="goBack" />

    <!-- 商标信息 -->
    <div class="product-card" v-if="proInfo">
      <div class="product-image">
        <img :src="proInfo.cover_img" :alt="proInfo.tit" />
      </div>
      <div class="product-info">
        <div class="product-name">{{ proInfo.tit }}</div>
        <div class="product-meta">
          <span>{{ proInfo.classify }}类 - {{ proInfo.classify_name }}</span>
        </div>
        <div class="product-price">
          <span class="price-label">售价</span>
          <span class="price-value">¥{{ formatPrice(displaySellingPrice) }}</span>
        </div>
      </div>
    </div>

    <!-- 交易类型 -->
    <div class="section-card">
      <div class="section-title">交易方式</div>
      <div class="notary-options">
        <div class="option-item active" v-if="canNotary === 0">
          <div class="option-icon">⚡</div>
          <div class="option-content">
            <div class="option-title">无公证</div>
            <div class="option-desc">直接付全款 → 交付资料</div>
            <div class="option-price" v-if="priceInfo.selling_price">
              支付 ¥{{ formatPrice(priceInfo.selling_price) }}
            </div>
          </div>
        </div>

        <div class="option-item active" v-if="canNotary === 1">
          <div class="option-icon">📋</div>
          <div class="option-content">
            <div class="option-title">有公证</div>
            <div class="option-desc">支付订金 → 公证 → 支付尾款 → 交付资料</div>
            <div class="option-price" v-if="priceInfo.deposit_amount">
              订金 ¥{{ formatPrice(priceInfo.deposit_amount) }}，尾款 ¥{{ formatPrice(priceInfo.final_amount) }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 联系人信息 -->
    <div class="section-card">
      <div class="section-title">联系人信息</div>
      <van-field
        v-model="form.buyerName"
        label="姓名"
        placeholder="请输入联系人姓名"
        :rules="[{ required: true, message: '请填写姓名' }]"
      />
      <van-field
        v-model="form.buyerPhone"
        label="电话"
        placeholder="请输入联系电话"
        type="tel"
        :rules="[{ required: true, message: '请填写电话' }]"
      />
      <van-field
        v-model="form.buyerCompany"
        label="公司（选填）"
        placeholder="请输入公司名称"
      />
      <van-field
        v-model="form.buyerRemark"
        label="备注（选填）"
        placeholder="如有特殊要求请填写"
        type="textarea"
        rows="2"
      />
    </div>

    <!-- 价格汇总 -->
    <div class="section-card price-summary" v-if="priceInfo.selling_price">
      <div class="price-row">
        <span>商标售价</span>
        <span>¥{{ formatPrice(priceInfo.selling_price) }}</span>
      </div>
      <div class="price-row" v-if="needNotary === 1">
        <span>本次支付（订金）</span>
        <span class="highlight">¥{{ formatPrice(priceInfo.deposit_amount) }}</span>
      </div>
      <div class="price-row" v-else>
        <span>本次支付</span>
        <span class="highlight">¥{{ formatPrice(priceInfo.selling_price) }}</span>
      </div>
      <div class="price-row total" v-if="needNotary === 1">
        <span>待付尾款</span>
        <span>¥{{ formatPrice(priceInfo.final_amount) }}</span>
      </div>
    </div>

    <!-- 底部提交 -->
    <div class="submit-bar">
      <div class="submit-info">
        <span class="submit-label">合计：</span>
        <span class="submit-price" v-if="needNotary === 1">
          ¥{{ formatPrice(priceInfo.deposit_amount) }}
        </span>
        <span class="submit-price" v-else>
          ¥{{ formatPrice(priceInfo.selling_price) }}
        </span>
      </div>
      <van-button
        type="danger"
        round
        class="submit-btn"
        :loading="submitting"
        @click="submitOrder"
      >
        提交订单
      </van-button>
    </div>

    <!-- 订单创建成功弹窗 -->
    <van-popup v-model="showSuccess" round closeable position="center" class="success-popup">
      <div class="success-content">
        <div class="success-icon">✅</div>
        <div class="success-title">订单创建成功</div>
        <div class="success-desc">请在24小时内完成支付</div>
        <div class="success-order" v-if="createdOrder">
          <div>订单号：{{ createdOrder.order_no }}</div>
          <div v-if="createdOrder.need_notary == 1">
            订金：¥{{ formatPrice(createdOrder.deposit_amount) }}
          </div>
          <div v-else>
            全款：¥{{ formatPrice(createdOrder.selling_price) }}
          </div>
        </div>
        <van-button type="danger" round block @click="goPay">
          立即支付
        </van-button>
        <van-button plain round block style="margin-top: 12px;" @click="goHome">
          稍后支付
        </van-button>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  name: 'OrderPage',
  data() {
    return {
      proId: null,
      proInfo: null,
      needNotary: 0,
      canNotary: 1,
      priceInfo: {},
      form: {
        buyerName: '',
        buyerPhone: '',
        buyerCompany: '',
        buyerRemark: ''
      },
      submitting: false,
      showSuccess: false,
      createdOrder: null
    }
  },
    created() {
    this.proId = this.$route.query.pro_id
    if (!this.proId) {
      this.$common.mAlert(this, '请选择商标')
      this.$router.back()
      return
    }
    this.loadProInfo()
    this.calcPrice()
  },
  computed: {
    displaySellingPrice() {
      if (this.priceInfo && this.priceInfo.selling_price) {
        return this.priceInfo.selling_price
      }
      if (this.proInfo) {
        return this.proInfo.display_price || this.proInfo.price || 0
      }
      return 0
    }
  },
  methods: {
    goBack() {
      this.$router.back()
    },
    goHome() {
      this.showSuccess = false
      this.$router.push('/payment')
    },
    goPay() {
      if (!this.createdOrder) return
      this.showSuccess = false
      
      // 直接复用 MyOrders.vue 里的支付逻辑，调用接口获取二维码
      this.executePay(
        this.createdOrder.id, 
        this.createdOrder.order_no, 
        this.createdOrder.need_notary == 1 ? this.createdOrder.deposit_amount : this.createdOrder.selling_price, 
        this.createdOrder.need_notary == 1 ? 'deposit' : 'full',
        this.createdOrder.status
      )
    },
    async executePay(orderId, orderNo, amount, type, initialStatus) {
      try {
        const formData = new FormData()
        formData.append('order_no', orderNo)
        formData.append('amount', amount)
        formData.append('type', type)

        const res = await this.$common.cusHttp(
          this,
          '/api/saas_order.php?action=pay',
          formData,
          'post'
        )
        
        const data = JSON.parse(res.data)
        if (data.status) {
          const qrCodeUrl = data.data.qrCodeUrl
          const isWechat = /MicroMessenger/i.test(navigator.userAgent)
          
          if (isWechat) {
            window.location.href = qrCodeUrl
          } else {
            // 跳转到订单列表页，并带上参数让列表页自动弹起支付二维码
            this.$router.push({
              path: '/my-orders',
              query: {
                pay_order_no: orderNo,
                pay_amount: amount,
                pay_type: type,
                pay_status: initialStatus,
                qr_url: encodeURIComponent(qrCodeUrl)
              }
            })
          }
        } else {
          this.$toast.fail(data.desc || '支付失败，请重试')
        }
      } catch (err) {
        console.error('支付请求失败:', err)
        this.$toast.fail('网络错误，请重试')
      }
    },
    // 加载商标信息
    async loadProInfo() {
      try {
        const res = await this.$common.cusHttp(
          this,
          `/api/saas_api.php?action=detail&pro_id=${this.proId}`,
          {},
          'get'
        )
        const data = JSON.parse(res.data)
        if (data.status) {
          this.proInfo = data.data
        }
      } catch (err) {
        console.error('加载商标信息失败:', err)
      }
    },
    // 计算价格
    async calcPrice() {
      try {
        const res = await this.$common.commonHttp(
          '/api/saas_order.php?action=calc_price',
          {
            pro_id: this.proId
          }
        )
        if (res.data.status) {
          this.priceInfo = res.data.data
          this.canNotary = res.data.data.can_notary
          this.needNotary = this.canNotary
        }
      } catch (err) {
        console.error('计算价格失败:', err)
      }
    },
    // 提交订单
    async submitOrder() {
      // 表单验证
      if (!this.form.buyerName.trim()) {
        this.$common.mAlert(this, '请填写联系人姓名')
        return
      }
      if (!this.form.buyerPhone.trim()) {
        this.$common.mAlert(this, '请填写联系电话')
        return
      }
      if (!/^1[3-9]\d{9}$/.test(this.form.buyerPhone)) {
        this.$common.mAlert(this, '请输入正确的手机号')
        return
      }

      this.submitting = true
      try {
        const inviterId = localStorage.getItem('saas_inviter_id') || 0
        const formData = new FormData()
        formData.append('pro_id', this.proId)
        formData.append('need_notary', this.needNotary)
        formData.append('buyer_name', this.form.buyerName)
        formData.append('buyer_phone', this.form.buyerPhone)
        formData.append('buyer_company', this.form.buyerCompany)
        formData.append('buyer_remark', this.form.buyerRemark)
        formData.append('inviter_id', inviterId)

        const res = await this.$common.cusHttp(
          this,
          '/api/saas_order.php?action=create_order',
          formData,
          'post'
        )
        const data = JSON.parse(res.data)
        if (data.status) {
          this.createdOrder = data.data
          this.showSuccess = true
        } else {
          this.$common.mAlert(this, data.msg || '创建订单失败')
        }
      } catch (err) {
        console.error('创建订单失败:', err)
        this.$common.mAlert(this, '创建订单失败，请重试')
      } finally {
        this.submitting = false
      }
    },
    // 格式化价格
    formatPrice(price) {
      if (!price || price <= 0) return '0'
      return Math.round(price).toLocaleString()
    }
  }
}
</script>

<style scoped>
.order-page {
  min-height: 100vh;
  background: #f5f5f5;
  padding-bottom: 80px;
}

.product-card {
  display: flex;
  padding: 16px;
  background: #fff;
  margin-bottom: 12px;
}

.product-image {
  width: 100px;
  height: 100px;
  border-radius: 8px;
  overflow: hidden;
  background: #f5f5f5;
  flex-shrink: 0;
}

.product-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.product-info {
  flex: 1;
  margin-left: 16px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.product-name {
  font-size: 16px;
  font-weight: 500;
  color: #333;
  line-height: 1.4;
}

.product-meta {
  font-size: 13px;
  color: #999;
}

.product-price {
  display: flex;
  align-items: center;
  gap: 8px;
}

.price-label {
  font-size: 13px;
  color: #666;
}

.price-value {
  font-size: 18px;
  font-weight: bold;
  color: #ee0a24;
}

.section-card {
  background: #fff;
  margin-bottom: 12px;
  padding: 16px;
}

.section-title {
  font-size: 15px;
  font-weight: 500;
  color: #333;
  margin-bottom: 16px;
}

/* 交易方式选项 */
.notary-options {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.option-item {
  display: flex;
  align-items: center;
  padding: 16px;
  border: 1px solid #e5e5e5;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
}

.option-item.active {
  border-color: #ee0a24;
  background: #fff5f5;
}

.option-icon {
  font-size: 24px;
  margin-right: 12px;
  flex-shrink: 0;
}

.option-content {
  flex: 1;
}

.option-title {
  font-size: 15px;
  font-weight: 500;
  color: #333;
  margin-bottom: 4px;
}

.option-desc {
  font-size: 12px;
  color: #999;
  margin-bottom: 8px;
}

.option-price {
  font-size: 13px;
  color: #ee0a24;
  font-weight: 500;
}

.option-check {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #ee0a24;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
}

.option-item:not(.active) .option-check {
  background: #e5e5e5;
}

/* 不支持公证提示 */
.notary-unsupported {
  background: #f5f5f5;
}

.notary-notice {
  display: flex;
  align-items: flex-start;
  padding: 12px;
  border: 1px dashed #ff8c00;
  border-radius: 8px;
  background: #fff;
}

.notice-icon {
  font-size: 24px;
  margin-right: 12px;
  flex-shrink: 0;
}

.notice-content {
  flex: 1;
}

.notice-title {
  font-size: 15px;
  font-weight: 500;
  color: #ff8c00;
  margin-bottom: 4px;
}

.notice-desc {
  font-size: 12px;
  color: #666;
  margin-bottom: 8px;
}

.notice-price {
  font-size: 13px;
  color: #ee0a24;
  font-weight: 500;
}

/* 价格汇总 */
.price-summary {
  margin-bottom: 100px;
}

.price-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px solid #f5f5f5;
  font-size: 14px;
  color: #666;
}

.price-row:last-child {
  border-bottom: none;
}

.price-row .highlight {
  color: #ee0a24;
  font-size: 16px;
  font-weight: 500;
}

.price-row.total {
  font-weight: 500;
  color: #333;
  font-size: 15px;
}

/* 底部提交 */
.submit-bar {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  height: 60px;
  background: #fff;
  display: flex;
  align-items: center;
  padding: 0 16px;
  box-shadow: 0 -2px 8px rgba(0,0,0,0.05);
}

.submit-info {
  flex: 1;
  display: flex;
  align-items: center;
  gap: 8px;
}

.submit-label {
  font-size: 14px;
  color: #666;
}

.submit-price {
  font-size: 20px;
  font-weight: bold;
  color: #ee0a24;
}

.submit-btn {
  width: 140px;
  height: 44px;
  font-size: 15px;
  background: linear-gradient(135deg, #ff6b6b, #ee0a24);
  border: none;
}

/* 成功弹窗 */
.success-popup {
  width: 80%;
  max-width: 320px;
  padding: 24px;
}

.success-content {
  text-align: center;
}

.success-icon {
  font-size: 48px;
  margin-bottom: 16px;
}

.success-title {
  font-size: 18px;
  font-weight: 500;
  color: #333;
  margin-bottom: 8px;
}

.success-desc {
  font-size: 13px;
  color: #999;
  margin-bottom: 16px;
}

.success-order {
  background: #f5f5f5;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 24px;
  font-size: 14px;
  color: #666;
  text-align: left;
}

.success-order div {
  margin-bottom: 8px;
}

.success-order div:last-child {
  margin-bottom: 0;
  color: #ee0a24;
  font-weight: 500;
}
</style>
